import { ENV } from "gatsby-env-variables"

const isDev = ENV === 'dev'

export default isDev
